import React, { useRef } from "react";
import { useState } from "react";
import TabSize from "./TabSize";
import axios from "axios";
import { useEffect } from "react";
import {
  Link,
  useParams,
  useLocation,
  useNavigate,
  NavLink,
} from "react-router-dom";
import Layout from "../component/Layout/Layout";
import parse from "html-react-parser";
//import ProductGallery from "./ProductGallery";
import ProductGallery from "./ProductGalleryVideo";
import ShimmerSingleBox from "../component/ShimmerSingleBox";
import AddtoWishlist from "./AddtoWishlist";
import PriceHtml from "./PriceHtml";
import SocialShare from "./SocialShare";
import {
  useCategoryChildAPI,
  useProductDetails,
} from "../hooks/useAllCategoryData";
import { useCart } from "../context/cart";
import { useAuth } from "../context/auth";
import {
  getFinalPricewithSymbol,
  getPriceSymbole,
  getRoundPrice,
  getPrice,
} from "../Helper";
import { getExchangeRate } from "../Helper";
import { getPriceCurrencyCode } from "../Helper";
import BreadcrumbsProductDetails from "./BreadcrumbsProductDetails";
import Rating from "../rating/Rating";
import Review from "../rating/Review";
import CountdownTimer from "./CountdownTimer";
import AddtoTryOn from "./AddtoTryOn";
import ProductConfigurator from "./ProductConfigurator";
import MtoPopup from "./MtoPopup";


function ProductDetail() {
  const [accordion, setAccordion] = useState({
    description: false,
    shipping: false,
    returns: false,
    quality: false,
    fit: false,
    sizeChart: false,
  });
  const openAccordion = (key) => {
    setAccordion((prev) => ({
      ...prev,
      [key]: true,
    }));
  };
  const toggleAccordion = (key) => {
    setAccordion((prev) => ({
      ...prev,
      [key]: !prev[key],
    }));
  };
  //console.log(getPriceCurrencyCode);
  let activeClassName = "active";
  let defoltClassName = "";
  const ref = useRef(null);

  const [isActive, setActive] = useState("false");

  const ToggleClass = () => {
    setActive(!isActive);
  };
  const [auth, setAuth] = useAuth();
  const symbol = getPriceSymbole();
  const exchangeRate = getExchangeRate();
  const currencyCode = getPriceCurrencyCode();
  const location = useLocation();
  const [cart, setCart] = useCart();
  const [lauth] = useAuth();
  const path = location.pathname.split("/");
  const [loading, setLoading] = useState(false);
  const [shimmer, setShimmer] = useState("shimmer-active");
  const navigate = useNavigate();
  const [colors, SetColors] = useState([]);
  const [choice, SetChoice] = useState([]);
  const [rtschoice, SetRtsChoice] = useState([]);
  const [mtochoice, SetMtoChoice] = useState([]);
  const [color_options, Setcolor_options] = useState([]);
  const [variation, SetVariation] = useState([]);
  const [enableAttribute, SetenableAttribute] = useState([]);
  const [selectedAttribute, setSelectedAttribute] = useState([]);
  const [selectedColours, setSelectedColours] = useState([]);
  const [cartqty, setCartQty] = useState(1);
  const [selColourState, setselColourState] = useState("");
  const [finalAmount, setFinalAmount] = useState(0);
  const [customMsg, setCustomMsg] = useState(false);
  const [cartData, SetCartData] = useState([]);
  const [catradded, SetCatradded] = useState(false);
  const [shippingtime, Setshippingtime] = useState("");
  const [categoryData, setCategoryData] = useState({ child_slugs: [] });
  const [showSecondPopup, setShowSecondPopup] = useState(() => {
    const stored = localStorage.getItem("secondPopupShown");
    return stored === null ? true : stored === "true";
  });
  const [welcomeDiscountEnable, setWecomeDiscountEnable] = useState(0);
  let [productDetail, setProductDetail] = useState([]);
  //Query Product Details
  const { isLoading, data: product } = useProductDetails(path);

  const [discount, setDiscount] = useState(0);

  const [isOpen, setIsOpen] = useState(false);

  let getProductDetail = async (data) => {
    try {
      if (data.id && data.status > 0) {
        if (data.attributes) {
          setProductDetail(data);
          //console.log(data)
          const parsedRts = JSON.parse(data.rts || "[]");
          setOrderType(parsedRts.length > 0 ? "RTS" : "MTO");
        }
        SetChoice(JSON.parse(data.choice_options));
        SetRtsChoice(JSON.parse(data.rts_variation));
        SetMtoChoice(JSON.parse(data.mto_variation));
        SetVariation(JSON.parse(data.variation));
        SetenableAttribute(JSON.parse(data.attributes));
        Setcolor_options(JSON.parse(data.color_options));
        Setshippingtime(data.shipping_time);

        /*Set Auto selected first chose options*/
        if (data.variation) {
          var defaultChoice = {};

          const rtsChoice = JSON.parse(data.rts_variation || "[]");
          const mtoChoice = JSON.parse(data.mto_variation || "[]");

          let defaultVariation = null;
          let discount = 0;

          // =========================
          // 1. Check RTS first
          // =========================
          if (rtsChoice.length > 0) {

            // First priority: L size with stock
            defaultVariation = rtsChoice.find(
              (x) => x.size?.trim() === "L" && Number(x.rts_qty) > 0
            );

            // If L not found, check 0, 1, 2, 3... sequentially
            if (!defaultVariation) {
              defaultVariation = rtsChoice.find(
                (x) => Number(x.rts_qty) > 0
              );
            }

            if (defaultVariation) {
              discount = Number(defaultVariation.rts_discount || 0);
            }
          }

          // =========================
          // 2. If RTS not found, check MTO
          // =========================
          if (!defaultVariation && mtoChoice.length > 0) {

            // Exclude CUSTOM TAILORED from MTO
            const validMtoChoice = mtoChoice.filter(
              (x) => x.size?.trim().toUpperCase() !== "CUSTOMTAILORED"
            );

            // First priority: L size with stock
            defaultVariation = validMtoChoice.find(
              (x) => x.size?.trim() === "L" && Number(x.qty) > 0
            );

            // If L not found, check 0, 1, 2... sequentially
            if (!defaultVariation) {
              defaultVariation = validMtoChoice.find(
                (x) => Number(x.qty) > 0
              );
            }

            if (defaultVariation) {
              discount = Number(defaultVariation.mto_discount || 0);
            }
          }

          // =========================
          // 3. Set selected variation
          // =========================
          if (defaultVariation) {
            defaultChoice.choice_2 =
              defaultVariation.size?.replace(/\s+/g, "");

            setFinalAmount(defaultVariation.price);
            setDiscount(discount);
          }
          console.log('defaultChoice====', defaultChoice);
          setSelectedAttribute(defaultChoice);
        }

        /*Set Auto selected color first options*/
        if (JSON.parse(data.colors).length > 0 && data.colors_name) {
          SetColors(JSON.parse(data.colors));
          setSelectedColours({
            ...selectedColours,
            ["color"]: data.colors_name,
          });
        }

        //FB Pixel Code: ViewContent
        if (typeof window !== "undefined") {
          if (window.fbq != null) {
            window.fbq("track", "ViewContent", {
              content_name: data.name,
              content_category: data?.catagories
                ? JSON.parse(data.catagories)[0]["name"]
                : "",
              content_ids: data.code,
              content_type: "product",
              value: getFinalPricewithSymbol(
                data.discount,
                data.discount_type,
                data.unit_price
              ),
              currency: "INR",
            });
          }
        }
      } else {
        navigate("/notfound", { replace: true });
      }

      setLoading(false);
      setShimmer("");
    } catch (error) {
      throw error;
    }
  };
  //console.log('productsss',productDetail)
  const handleChangeAttribute = (e) => {
    const cvalue = e.target.value.replace(/\s+/g, "");

    setSelectedAttribute((prev) => ({
      ...prev,
      [e.target.name]: cvalue,
    }));

    if (e.target.name === "choice_2") {
      if (cvalue === "CUSTOMTAILORED") {
        /* setTimeout(() => {
          ref.current?.scrollIntoView({ behavior: "smooth" });
        }, 700); */

        setCustomMsg(true);
      } else {
        setCustomMsg(false);
      }

      let selectedVariation = null;

      if (orderType === "RTS") {
        selectedVariation = rtschoice.find(
          (item) => item.size.replace(/\s+/g, "") === cvalue
        );
      } else {
        selectedVariation = mtochoice.find(
          (item) => item.size.replace(/\s+/g, "") === cvalue
        );
      }

      if (selectedVariation) {
        setFinalAmount(selectedVariation.price);
        setDiscount(
          orderType === "RTS"
            ? selectedVariation.rts_discount
            : selectedVariation.mto_discount
        );
      }
    }

    // Keep this only if other attributes (color, fabric, etc.) still depend on variation[]
    if (variation.length > 0) {
      getVariantPrice();
    }
  };

  const handleChangeColors = (e) => {
    const value = e.target.value;
    //const value = 'ForestGreen';
    // alert(e.target.name + '==='+ e.target.value)
    setSelectedColours({
      ...selectedColours,
      [e.target.name]: value,
    });
    if (colors.length > 0) {
      getVariantPrice();
    }
    //console.log(selectedColours);
  };

  let getVariantPrice = (k) => {
    /* console.log('------')
    console.log(selectedAttribute) */
    SetCatradded(false);
    var NoOfAttributeActive = enableAttribute.length;
    var NoOfSelectedAttribute = Object.keys(selectedAttribute).length;
    var selectedColourOption;
    var error = true;

    /*  alert(NoOfAttributeActive);
    alert(NoOfSelectedAttribute); */

    selectedColourOption =
      colors.length < 1 && selectedColours.length < 1 ? "" : selectedColours;
    //console.log(selectedColourOption)

    //For color option selected of not and if color option is enable
    /* if (colors.length > 0 && selectedColours.length < 1) {
      alert("Please Select Color Options");
      error = false;
    }
  
    //For attribute option not selected.
    if (NoOfAttributeActive !== NoOfSelectedAttribute) {
      alert("Please Select Options");
      error = false;
    }
  */
    if (error) {
      var selAtt = Object.values(selectedAttribute);

      selAtt = selAtt.sort();
      selAtt = selAtt.join("-");
      var selSize = selAtt;
      if (selectedColourOption) {
        setselColourState(selectedColours.color);
        selAtt = selectedColours.color + "-" + selAtt;
      }

      let filtered = [];
      for (let j = 0; j < variation.length; j++) {
        if (selAtt === variation[j].type) {
          filtered.push(variation[j]);
        }
      }
      //console.log(selAtt);
      var finalCartPri = finalAmount;
      //return false;
      /*  const filtered = variation.filter(selvar => selvar.sku.includes(selAtt)); */
      if (filtered.length > 0) {
        setFinalAmount(filtered[0].price * cartqty);
        //console.log(filtered[0].shipping_time);
        Setshippingtime(filtered[0].shipping_time);
        if (productDetail.discount !== 0) {
          finalCartPri = Math.round(
            filtered[0].price -
            ((filtered[0].price * productDetail.discount) / 100) * cartqty
          );
        } else {
          finalCartPri = filtered[0].price * cartqty;
        }
      }

      var sel_data = {
        ["product_id"]: productDetail.id,
        ["price"]: finalCartPri,
        ["choices"]: selectedAttribute,
        ["variant"]: selAtt,
        ["order_type"]: orderType, // RTS or MTO
        ["variations"]: { color: selectedColours.color, Size: selSize },
        ["color"]: JSON.parse(productDetail.colors)[0],
      };
      SetCartData({
        ...cartData,
        ...sel_data,
      });
    }
  };

  let AddToCart = async (redirect) => {
    getProductDetail();
    //alert(finalAmount);

    const c_data = {
      ...cartData,
      ["customer_id"]: lauth?.user ? lauth.user.id : 0,
      ["quantity"]: cartqty,
      ["order_type"]: orderType, // RTS or MTO
      ["slug"]: productDetail.slug,
      ["name"]: productDetail.name,
      ["thumbnail"]: productDetail.thumbnail,
    };
    SetCartData(c_data);

    //console.log("c_data", c_data);
    const addCarttoDatabase = async (dataArr) => {
      if (dataArr.customer_id !== "") {
        let cart_data = {
          id: dataArr.product_id,
          product_id: dataArr.product_id,
          color: dataArr.color,
          choice_2: dataArr.variations.Size,
          quantity: dataArr.quantity,
          order_type: dataArr.order_type, // RTS or MTO
          customer_id: dataArr.customer_id,
          price_data: { currency: symbol, exchange_rate: exchangeRate },
        };

        try {
          let { data } = await axios.post(
            `${process.env.REACT_APP_API_URL}/cart/add`,
            cart_data
          );
          // console.log(data); return false;
          if (data?.status) {
            return data;
          }
        } catch (error) {
          console.log(error);
        }
      }
    };

    //let existingCartItem = localStorage.getItem("cart");
    let existingCartItem = cart
      ? cart
      : JSON.parse(localStorage.getItem("cart"));
    //console.log('cart cc', existingCartItem)
    if (existingCartItem) {
      var exist = false;
      const filtered = existingCartItem.filter((element, index, array) => {
        if (
          String(element.variant) === String(c_data.variant) &&
          element.product_id === c_data.product_id
        ) {
          exist = true;
        }
      });
      if (exist) {
        if (redirect) {
          navigate("/checkout");
        } else {
          alert("Already Added in cart");
        }
      } else {

        existingCartItem = [...existingCartItem, c_data];
        localStorage.setItem("cart", JSON.stringify(existingCartItem));
        setCart(existingCartItem);


        if (redirect) {
          navigate("/checkout");
        }

        /* SetCatradded(true);
        addCarttoDatabase(c_data); */
        const response = await addCarttoDatabase(c_data);

        if (response?.status) {
          SetCatradded(true);

          // Refresh cart from API
          setCart(existingCartItem);
        }
      }
    } else {
      localStorage.setItem("cart", JSON.stringify([c_data]));
      setCart([c_data]);
      if (redirect) {
        navigate("/checkout");
      }
      /* SetCatradded(true);
      addCarttoDatabase(c_data); */
      const response = await addCarttoDatabase(c_data);

      if (response?.status) {
        SetCatradded(true);

        // Refresh cart from API
        setCart(existingCartItem);
      }
    }
    if (typeof window !== "undefined") {
      if (window.fbq != null) {
        window.fbq("track", "AddToCart", {
          content_ids: productDetail.code,
          content_name: productDetail.name,
          content_type: "product",
          value: c_data.price,
          currency: "INR",
        });
      }
    }

    // console.log(c_data)
  };
  let activeReadyToShip = (curSize) => {
    //console.log('object',curSize)

    let filtered = [];
    for (let j = 0; j < variation.length; j++) {
      if (curSize === variation[j].type) {
        filtered.push(variation[j]);
        if (variation[j].shipping_time === "Within 7 days") {
          return "rtd-light";
        } else {
          return "";
        }
      }
    }
    //  console.log(filtered)
  };
  useEffect(() => {
    setLoading(true);
    if (!isLoading) {
      getProductDetail(product);
      // console.log(product)
    }
    //eslint-disable-next-line
  }, [product]);

  useEffect(() => {
    //console.log(selectedAttribute)
    // console.log(cartData)
    if (variation.length > 0) {
      getVariantPrice();
      // AddToCart();
    }
    //eslint-disable-next-line
  }, [selectedAttribute, selectedColours]);

  useEffect(() => {
    //eslint-disable-next-line
  }, [cart]);

  const getWelComeDiscount = async () => {
    let { data } = await axios.get(
      `${process.env.REACT_APP_API_URL}/static/welcomediscount`
    );
    if (data?.status) {
      setWecomeDiscountEnable(data?.status);
    }
  };
  useEffect(() => {
    if (auth?.user?.id) {
      getWelComeDiscount();
    }
    //eslint-disable-next-line
  }, [auth?.user?.id]);


  const handleCLoseSecondPopup = () => {
    setShowSecondPopup(false);
    localStorage.setItem("secondPopupShown", "false");
  };
  const objectInRowByKeys = (value) => {
    const filtered = variation.filter((element) => element.type === value);
    if (filtered.length > 0 && filtered[0].qty < 1) {
      return 1;
    }
    return 0;
  };
  //console.log(JSON.parse(productDetail.images)[0])
  var fbPrice = 0;
  let fbGraphData = {};
  if (productDetail?.unit_price !== "") {

    fbPrice = getFinalPricewithSymbol(
      productDetail.discount,
      productDetail.discount_type,
      productDetail.unit_price
    );

    if (!isNaN(fbPrice)) {
      //fbPrice = getPrice(fbPrice,false);
      fbGraphData = {
        id: productDetail?.code,
        availability:
          productDetail.current_stock > 0 ? "in stock" : "out of stock",
        amount: fbPrice,
        currency: "INR",
      };
    }
  }

  const getCategories = (categories) => {
    if (typeof categories === "string") {
      try {
        return JSON.parse(categories);
      } catch (error) {
        console.error("Invalid JSON format in categories:", error);
        return [];
      }
    }
    return Array.isArray(categories) ? categories : [];
  };

  // Ensure `productDetail` is defined before using it
  const categories = getCategories(productDetail?.catagories);

  const categorySlug = categories?.[0]?.slug || null;

  const { data } = useCategoryChildAPI(categorySlug || "");

  useEffect(() => {
    //console.log("Received API Data:", data);
    if (data) {
      setCategoryData(data);
    }
  }, [data]);

  const [orderType, setOrderType] = useState('RTS'); // 'RTS' or 'MTO'

  const handleOrderTypeChange = (type) => {
    setOrderType(type);

    const choice = type === "RTS" ? rtschoice : mtochoice;
    if (choice.length > 0) {
    const defaultVariation =
        choice.find(
          (x) =>
            x.size?.trim() === "L" &&
            Number(type === "RTS" ? x.rts_qty : x.qty) > 0
        ) ||
        choice.find(
          (x) => Number(type === "RTS" ? x.rts_qty : x.qty) > 0
        ); 

      /*   const defaultVariation =
        choice.find(
          (x) =>
            x.size?.trim() === "CUSTOMTAILORED" &&
            Number(type === "RTS" ? x.rts_qty : x.qty) > 0
        ) ||
        choice.find(
          (x) => Number(type === "RTS" ? x.rts_qty : x.qty) > 0
        ); */


      if (defaultVariation) {
        const defaultChoice = {
          ...selectedAttribute,
          choice_2: defaultVariation.size.replace(/\s+/g, ""),
        };

        setSelectedAttribute(defaultChoice);
        setFinalAmount(defaultVariation.price);
        setDiscount(
          Number(
            type === "RTS"
              ? defaultVariation.rts_discount
              : defaultVariation.mto_discount
          )
        );
      }
    }

    setCustomMsg(false);
  };
  const rts = (() => {
    try {
      return JSON.parse(productDetail?.rts || "[]");
    } catch {
      return [];
    }
  })();

  const mto = (() => {
    try {
      return JSON.parse(productDetail?.mto || "[]");
    } catch {
      return [];
    }
  })();
  const sortingArr = [
    "XS",
    "S",
    "M",
    "L",
    "XL",
    "2XL",
    "3XL",
    "4XL",
    "5XL",
    "6XL",
    "CUSTOMTAILORED",
  ];


  const sortedRtsChoice = rtschoice
    .filter(
      (item) =>
        item.type.replace(/\s+/g, "").toUpperCase() !== "CUSTOMTAILORED"
    )
    .sort(
      (a, b) =>
        sortingArr.indexOf(a.type.trim()) -
        sortingArr.indexOf(b.type.trim())
    );

  const customTailored = mtochoice.find(
    (item) =>
      item.size.replace(/\s+/g, "").toUpperCase() === "CUSTOMTAILORED"
  );

  const sortedMtoChoice = mtochoice
    .filter(
      (item) =>
        item.size.replace(/\s+/g, "").toUpperCase() !== "CUSTOMTAILORED"
    )
    .sort(
      (a, b) =>
        sortingArr.indexOf(a.size.trim()) -
        sortingArr.indexOf(b.size.trim())
    );
  const handleMeasurementClick = () => {

    /* setTimeout(function () {
      ref.current?.scrollIntoView({ behavior: "smooth" });
    }, 700); */
    setCustomMsg(true);

  };
  return (
    <Layout
      productTag={fbGraphData}
      title={
        productDetail.meta_title ? productDetail.meta_title : productDetail.name
      }
      description={
        productDetail.meta_description
          ? productDetail.meta_description
          : productDetail.name
      }
      keywords={productDetail.meta_keywords ? productDetail.meta_keywords : ""}
      image={
        productDetail.images
          ? `${process.env.REACT_APP_API_ROOT}/storage/app/public/product/${JSON.parse(productDetail.images)[0]
          }`
          : ""
      }
    >
      <div
        className="site-content-wrap product-list product-detail-page-wrap"
        id={productDetail.id ? "page_" + productDetail.id : ""}
      >
        <div className="container">
          <div className="row"> {productDetail?.is_friday_sale === 1 && (
            <div className="col-md-12 friday-banner"> <img
              src="../images/friday_sale_banner_product_page.jpg"
              alt="Friday Sale Banner"
            /> </div>
          )}
            <div className="col-md-6 col-sm-12 col-xs-12 mb-40 custom_gallery"> {loading ? (
              <div className="products-gallery"> {Array.from({ length: 4 }, (_, index) => (
                <ShimmerSingleBox
                  key={index}
                  CustomStyle={{ height: "475px" }}
                />
              ))} </div>
            ) : (
              <ProductGallery
                key="1"
                images={productDetail.images}
                short_video={productDetail.short_video}
                long_video={productDetail.long_video}
                discount={productDetail.discount}
                featured={productDetail.featured}
              />
            )} </div>
            <div className="col-md-6 col-sm-12 col-xs-12 mb-40">
              <div className="product-details">
                <div className="social-share">{productDetail?.is_friday_sale != 1 && ( <AddtoWishlist p_id={productDetail.id} /> )} <SocialShare /></div>
                <h1 className="short-desc-box" shimmer={shimmer}>
                  <p>{productDetail.name} </p>
                </h1>
                <h6 className="sku-box" shimmer={shimmer}> <span className="item-code-span">Product Code/SKU: {productDetail.code}</span> <span className={`item-code-box  ${orderType === 'RTS' ? 'rts-active' : 'mto-active'}`}> {rts.length > 0 && (<span className="badge badge-rts"><i class="fa-solid fa-bolt"></i> RTS</span>)}
                  {mto.length > 0 && (<span className="badge badge-mto">{/* 🪄 */} <i class="fa-solid fa-scissors"></i> MTO</span>)} </span> </h6>
                {productDetail?.reviews_count > 0 && (
                  <Rating
                    totCount={productDetail?.reviews_count}
                    reviews={productDetail?.reviews}
                    reviewlink="true"
                  />
                )}
                {(rts.length > 0 || mto.length > 0) && (
                  <div className={`product-card  ${(rts.length > 0 && mto.length > 0) ? '' : 'single-box'} `}>
                    {/* Order Type Toggle Boxes */}
                    {(rts.length > 0 && mto.length > 0) && (
                      <label className="product-card-label">Choose an order type:</label>
                    )}
                    <div className={`toggle-container  ${orderType === 'RTS' ? 'rts-active' : 'mto-active'}`}> {rts.length > 0 && (
                      <button onClick={() => handleOrderTypeChange('RTS')} className={`toggle-box rts-box ${orderType === 'RTS' ? 'active' : ''}`}>
                        <div className="toggle-title">RTS (Ready to Ship)</div>
                        <div className="toggle-subtitle">Limited Sizes Available {/*Available Sizes */} {/*:  {rts?.join(", ")} */}</div>
                        {/* <div className="toggle-delivery">Ships in 3 days</div> */}
                      </button>
                    )}
                      {mto.length > 0 && (
                        <button onClick={() => handleOrderTypeChange('MTO')} className={`toggle-box mto-box ${orderType === 'MTO' ? 'active' : ''}`}>
                          <div className="toggle-title">MTO (Made to Order)</div>
                          <div className="toggle-subtitle">Multiple Sizes and Customization{/*:  {mto?.filter(item => item !== "CUSTOMTAILORED").join(", ")} */}</div>
                          {/* <div className="toggle-delivery">Ships in {productDetail?.shipping_time}</div> */}
                        </button>
                      )} </div>
                    {/* Size Selection Section */}
                    {orderType === 'MTO' && (
                      <div className="size-section">
                        
                        <div className="size-section-box" > 
                        <label className="section-label">Choose Size:</label>
                        <div className="size-options-row">
                         <div className="dropdown-wrapper">
                            <select
                              value={selectedAttribute?.choice_2 || ""}
                              name="choice_2"
                              onChange={handleChangeAttribute}
                              className={`size-dropdown ${customMsg ? "" : "custom-active"}`}
                            >
                              {sortedMtoChoice.map((item) => (
                                <option
                                  key={item.size}
                                  value={item.size}
                                  disabled={Number(item.qty) < 1}
                                >
                                  {item.size} {Number(item.qty) < 1 ? "" : ""}
                                </option>
                              ))}
                            </select>
                          </div> 
                          {customTailored && (
                            <><span>or</span>
                            <button
                             className={`measurement-btn ${customMsg ? "custom-active" : ""}`} name="choice_2" value="CUSTOMTAILORED"
                              onClick={handleChangeAttribute}> Made to Measurement </button></>
                          )} 
                           
                             {/*<a href='#size-chart' className="size-chart-link" onClick={() => openAccordion("sizeChart")}>Size Chart</a>*/}
                          
                          </div>
                          </div>

                          <div className="policy-notice-box"> {/* <i class="fa-solid fa-info"></i> */} <a href="#" className="i-icon-product" title="More info"  onClick={() => setIsOpen(true)}><i class="fa-solid fa-circle-info"></i></a>
                          {/* <div>
                            <p>Order in your size. We will guide you through the measurement process.</p>
                            <p>Pay in 3 stages (50% / 25% / 25%), with photo & video updates throughout. <a href="#"  onClick={() => setIsOpen(true)}>More Details</a></p>
                          </div> */}
                        </div>
                          
                      </div>
                    )}
                  </div>
                )}
                <div className="product-size-tab" shimmer={shimmer}>
                  {/* {colors.length > 0 && productDetail.colors_name && (
                  <>
                    <h3 style={colors.length === 1 && { display: "none" }}>Choose Color:</h3>
                    <div className="tab-nav" style={colors.length === 1 && { display: "none" }}>
                      <ul className="size-box">
                        {colors &&
                          colors?.map((k, i) => {
                            return (
                              <li key={i}>
                                <input
                                  type="radio"
                                  name="color"
                                  id={"color_" + i}
                                  value={productDetail.colors_name}
                                  onChange={handleChangeColors}
                                  checked={
                                    selectedColours["color"] ===
                                    productDetail.colors_name
                                  }
                                />
                                <label
                                  for={"color_" + i}
                                  style={{ background: k }}
                                ></label>
                              </li>
                            );
                          })}
                      </ul>
                    </div>
                  </>
                )} */}

                  {/* Otions start  rtschoice  */}
                  {sortedRtsChoice.length > 0 && orderType === 'RTS' && (
                    <>
                    
                      <h3>Choose Size:</h3>
                      <div className="tab-nav">
                        <ul className="size-box">
                          {sortedRtsChoice.map((item, i) => (
                            <li key={i}>
                              <input
                                type="radio"
                                id={`choice_2_${item.size}`}
                                name="choice_2"
                                onChange={handleChangeAttribute}
                                checked={
                                  selectedAttribute['choice_2'] ===
                                  item.size.replace(/\s+/g, "")
                                }
                                value={
                                  selectedAttribute['choice_2'] &&
                                    selectedAttribute['choice_2'] ===
                                    item.size
                                    ? selectedAttribute['choice_2']
                                    : item.size
                                }
                              />
                              <label htmlFor={`choice_2_${item.size}`}> {item.size} </label>
                            </li>
                          ))}
                           {/* <li> <a
                            href="#size-chart"
                            className="size-chart"
                            onClick={() => openAccordion("fit")}
                          > Size Chart </a> </li> */}
                        </ul>
                      </div>
                    </>
                  )}
                  {!!finalAmount && !!selectedAttribute && (rts.length > 0 || mto.length > 0) && (
                    <>

                      <PriceHtml
                        pdata={{
                          discount: discount, //productDetail.discount,
                          discount_type: "percent", //productDetail.discount_type,
                          price: finalAmount,
                          symbol: symbol,
                          divclass: "price-box",
                          shipping_time: shippingtime,
                          pagefrom: "productDetails",
                          coupon_message: productDetail.coupon_message,
                          is_details_page: 1,
                          sku: productDetail.code,
                          is_friday_sale: productDetail.is_friday_sale,
                        }}
                        welcomeDiscountEnable={welcomeDiscountEnable}
                        auth={auth}
                      />

                      {/*  <div className="policy-notice"> {orderType === 'RTS' ? (<span>Item eligible for standard return policies.</span>) : (
                        <> <span>MTO Orders are non-returnable <i class="fa-solid fa-circle-info" title="Custom orders cannot be returned"></i></span> </>
                      )} </div> */}
                      {/* {customMsg && (
                      <div className="policy-notice"><span>Pay in 3 stages (50% / 25% / 25%), with photo & video updates throughout. <a href="#">More Details</a></span></div>
                      )} */}
                    </>
                  )}
                  <div className="add-cart">
                    <input
                      type="hidden"
                      id=""
                      className="input-text qty text"
                      name="quantity"
                      value="1"
                      size="4"
                      min="1"
                      max=""
                      step="1"
                      placeholder=""
                      inputmode="numeric"
                      autocomplete="off"
                    />
                    {productDetail?.current_stock < 1 ? (<span className="sold-out-text">SOLD OUT</span>) : (
                      <>
                        {!!finalAmount && !!selectedAttribute && (rts.length > 0 || mto.length > 0) && productDetail?.is_friday_sale !== 1 && (
                          <button
                            type="button"
                            onClick={(e) => AddToCart()}
                            className={`cart-btn outline-btn ${catradded ? "added" : ""}`}
                            disabled={productDetail?.current_stock < 1}
                          >
                            ADD TO CART </button>
                        )}
                        {/* {productDetail?.is_friday_sale != 1 && (
                          <AddtoWishlist p_id={productDetail.id} />
                        )} */}
                      </>
                    )}
                    <div className="whatapp-detail-box">
                      <Link
                        target="_blank"
                        to={`https://wa.me/${process.env.REACT_APP_WHATSAPP_NO}?text=Hello%2C+I+have+a+query+regarding+custom+tailored+${productDetail.code}`}
                        className="custom-whatapp-link"
                      >
                        <i className="fa-brands fa-whatsapp"></i> CHAT WITH US
                      </Link>
                      
                    </div>
                    <div className="whatapp-box">to ask about real photos, video calls, fit, <br /> customization, early delivery - anything.</div>
                  </div>
                </div>
                {color_options.length > 1 && (
                  <div className="related-product">
                    <h5>Color Options:</h5>
                    <nav>
                      <ul>
                        {color_options?.map((key, i) => {
                          return (
                            <li key={i}>
                              <NavLink
                                className={({ isActive }) => isActive ? activeClassName : defoltClassName
                                }
                                to={`/product/${key.slug}`}
                              > <img
                                  src={`${process.env.REACT_APP_API_ROOT}/storage/app/public/product/thumbnail/${key.images}`}
                                  alt=""
                                /> </NavLink>
                            </li>
                          );
                        })}
                      </ul>
                    </nav>
                  </div>
                )}
                {/* Guarantees Row has-divider*/}
                <div className="guarantees-grid-wrap ">
                  <div className="guarantees-grid">
                    
                    {orderType === 'RTS' ? (
                    <span className="guarantee-item" style={{"minWidth":"72px"}}> <img src="/images/product-icon/delivery-truck.png" alt="3 Days Returnable" /> <span className="guarantee-text">Ships in <br /> 0-2 Weeks</span> </span>
                  ) : (
                    <><span className="guarantee-item"  style={{"minWidth":"72px"}}> <img src="/images/product-icon/delivery-truck.png" alt="3 Days Returnable" />  <span className="guarantee-text">Ships in <br />{productDetail?.shipping_time}</span> </span>
                    {/* <a href="#guaranteed" onClick={() => openAccordion("guaranteed")} className="guarantee-item"> <img src="/images/product-icon/satisfaction-guaranteed.png" alt="Satisfaction Guaranteed" /> <span className="guarantee-text">Satisfaction <br /> Guaranteed</span> </a> */}</>
                  )}
                    
                     {orderType === 'RTS' ? (
                    <a href="#return" onClick={() => openAccordion("returns")} className="guarantee-item"> <img src="/images/product-icon/icon-3-days-returnable.png" alt="3 Days Returnable" /> <span className="guarantee-text">3 Days <br />
                      Returnable</span> </a>
                  ) : (
                    <><a href="#return" onClick={() => openAccordion("returns")} className="guarantee-item"> <img src="/images/product-icon/icon-3-days-returnable.png" alt="3 Days Returnable" /> <span className="guarantee-text">Non <br /> Returnable</span> </a>
                    {/* <a href="#guaranteed" onClick={() => openAccordion("guaranteed")} className="guarantee-item"> <img src="/images/product-icon/satisfaction-guaranteed.png" alt="Satisfaction Guaranteed" /> <span className="guarantee-text">Satisfaction <br /> Guaranteed</span> </a> */}</>
                  )}
                    <a href="#shipping" onClick={() => openAccordion("shipping")} className="guarantee-item"> <img src="/images/product-icon/free-delivery.png" alt="Free Delivery" /> <span className="guarantee-text">Free <br />
                      Delivery</span> </a>
                    <a href="#shipping" onClick={() => openAccordion("shipping")} className="guarantee-item"> <img src="/images/product-icon/shipping-worldwide.png" alt="Shipping Worldwide" /> <span className="guarantee-text">Shipping <br />
                      Worldwide</span> </a>
                    <a href="#assured-quality" onClick={() => openAccordion("quality")} className="guarantee-item"> <img src="/images/product-icon/assured-quality.png" alt="Assured Quality" /> <span className="guarantee-text">Assured <br />
                      Quality</span> </a>
                    <a href="#securepayments" onClick={() => openAccordion("securepayments")} className="guarantee-item"> <img src="/images/product-icon/satisfaction-guaranteed.png" alt="Secured Payments" /> <span className="guarantee-text">Secured <br />
                      Payments</span> </a>
                  </div>
                  {/* <div className="guarantees-grid-text">
                    <p>Click for more info.</p>
                  </div> */}
                </div>
                {/* {customMsg && (
                  <div
                    className="short-desc custom-box ship-box no-icons newdes-box"
                    id="custom-size"
                    style={{ display: "block" }}
                  > <span className="custom-box" ref={ref}></span>
                    <ul>
                      <li>Same style as per your measurements?</li>
                      <li>Same style in a bespoke color?</li>
                      <li>Early delivery?</li>
                      <li>International delivery?</li>
                      <li>Live product preview?</li>
                      <li>Any other questions?</li>
                    </ul>
                    <div className="whatup-box">
                      <Link
                        target="_blank"
                        to={`https://wa.me/${process.env.REACT_APP_WHATSAPP_NO}?text=Hello%2C+I+have+a+query+regarding+custom+tailored+${productDetail.code}`}
                        className="custom-whatapp-icon"
                      >
                        CHAT WITH US
                      </Link>
                    </div>
                  </div>
                )} */}
                {/*
          <div className="product-description-confidence">
                  <div className="product-description-box">
              <h5>PRODUCT DESCRIPTION</h5>
              <div className="product-description" shimmer={shimmer}> {productDetail.details
                      ? parse(productDetail.details)
                      : ""} </div>
              <div
                      className="about-product-description"
                      shimmer={shimmer}
                    >
                      <ul>
                  <li> <span>Fabric: </span> {productDetail.fabric} </li>
                  <li> <span>Embroidery: </span> {productDetail.embroidery} </li>
                  <li> <span>Care Instruction: </span> {productDetail.care} </li>
                  <li> <span>Fit: </span> {productDetail.fit} </li>
                </ul>
                    </div>
            </div>
                </div>
          <div className="whatsapp-box has-divider"> <span> <strong>Questions or Customisations?</strong>{" "}
            <Link
                      to={`https://wa.me/${process.env.REACT_APP_WHATSAPP_NO}?text=Hello%2C+I+have+a+query+regarding+${productDetail.code}.`}
                      rel="noopener noreferrer"
                      className="whatapp-icon-img"
                      target="_blank"
                    >
            <u>Message Us</u>
            </Link>
            {" "}
            or get on a{" "}
            <Link
                      to={`https://wa.me/${process.env.REACT_APP_WHATSAPP_NO}?text=Hello%2C+Can+i+view+this+item+${productDetail.code}+on+a+video+call%3F`}
                      rel="noopener noreferrer"
                      className="whatapp-icon-img-call"
                      target="_blank"
                    >
            <u>Video Call</u>
            </Link>
            {" "}
            with our friendly Style Executive. </span> </div>
          <div className="chaashni-product has-divider">
                  <picture>
              <source
                      media="(min-width:768px)"
                      srcSet="../images/Product-Page-Icons-v3.svg"
                    />
              <source
                      media="(min-width:1px)"
                      srcSet="../images/Product-Page-Mobile-Icons-5.svg"
                    />
              <img src="../images/Product-Page-Icons-v3.svg" alt="" /> </picture>
                </div>
          <div className="product-description-confidence tab-panel-main has-divider"> <span id="tab-panel-box" />
                  <div className="product-description-box">
              <h5>SIZE CHART</h5>
              <div className="tab-pane-size">
                      <div className="size-left">
                  <TabSize />
                  <div className="note-box">
                          <p> <span>Note:</span> This is a standard size guide for the basic body measurements. Length of garments may vary as per style and type. </p>
                        </div>
                  <div className="measurements-box"> <img src="../images/video-call-blue.png" alt="" />
                          <Link to="/measurements" target="_blank">
                          How to take Measurements
                          </Link>
                        </div>
                </div>
                      <div className="size-right"> <img src="../images/measurement-img.png" alt="img" /> </div>
                    </div>
            </div>
                </div>
          {productDetail?.reviews_count > 0 && (
          <div className="review-box has-divider">
                  <Review
                      totCount={productDetail?.reviews_count}
                      reviews={productDetail?.reviews}
                    />
                </div>
          )}
          <div className="product-description-confidence borderno">
                  <p className="useful-links"> <span>Useful Links: </span>{" "}
              <Link to="/pages/returns-exchanges-and-cancellations">
              Returns, Exchanges and Cancellations
              </Link>
              {" "}
              |{" "}
              <Link to="/pages/shipping-information">
              Shipping Information
              </Link>
            </p>
                </div>
          */}
                <div className="product-description-confidence"> {/* Product Description */}
                  <div className="accordion-item-box">
                    <span className="accordion-item-span" id=""></span>
                    <div
                      className="accordion-header"
                      onClick={() => toggleAccordion("description")}
                    >
                      <h5>PRODUCT DESCRIPTION</h5>
                      <span className={accordion.description ? "open" : ""}><img src="../images/arrow-down.png" alt="" /></span> </div>
                    <div
                      className={`accordion-content ${accordion.description ? "show" : ""
                        }`}
                    >
                      <div className="product-description" shimmer={shimmer}> {productDetail.details ? parse(productDetail.details) : ""} </div>
                      <div
                        className="about-product-description"
                        shimmer={shimmer}
                      >
                        <ul>
                          <li><span>Fabric:</span> {productDetail.fabric}</li>
                          <li><span>Embroidery:</span> {productDetail.embroidery}</li>
                          <li><span>Care Instruction:</span> {productDetail.care}</li>
                          <li><span>Fit:</span> {productDetail.fit}</li>
                        </ul>
                      </div>
                    </div>
                  </div>

                  {/* Returns */}
                  <div className="accordion-item-box">
                    <span className="accordion-item-span" id="return"></span>
                    <div
                      className="accordion-header"
                      onClick={() => toggleAccordion("returns")}
                    >
                      <h5>RETURNS AND CANCELLATION</h5>
                      <span className={accordion.returns ? "open" : ""}><img src="../images/arrow-down.png" alt="" /></span> </div>
                    <div
                      className={`accordion-content ${accordion.returns ? "show" : ""
                        }`}
                    >
                      <div dangerouslySetInnerHTML={{ __html: productDetail?.returns_info || "", }} />
                    </div>
                  </div>

                  {/* Shipping */}
                  <div className="accordion-item-box">
                    <span className="accordion-item-span" id="shipping"></span>
                    <div
                      className="accordion-header"
                      onClick={() => toggleAccordion("shipping")}
                    >
                      <h5>SHIPPING INFORMATION</h5>
                      <span className={accordion.shipping ? "open" : ""}><img src="../images/arrow-down.png" alt="" /></span> </div>
                    <div
                      className={`accordion-content ${accordion.shipping ? "show" : ""
                        }`}
                    >
                      <div dangerouslySetInnerHTML={{ __html: productDetail?.shipping_info || "", }} />
                    </div>
                  </div>

                  {/* Quality Assurance */}
                  <div className="accordion-item-box">
                    <span className="accordion-item-span" id="assured-quality"></span>
                    <div
                      className="accordion-header"
                      onClick={() => toggleAccordion("quality")}
                    >
                      <h5>QUALITY AND ASSURANCE</h5>
                      <span className={accordion.quality ? "open" : ""}><img src="../images/arrow-down.png" alt="" /></span> </div>
                    <div
                      className={`accordion-content ${accordion.quality ? "show" : ""
                        }`}
                    >
                      <div dangerouslySetInnerHTML={{ __html: productDetail?.quality_assurance || "", }} />
                    </div>
                  </div>

                  {/* Shipping */}
                  <div className="accordion-item-box">
                    <span className="accordion-item-span" id="securepayments"></span>
                    <div
                      className="accordion-header"
                      onClick={() => toggleAccordion("securepayments")}
                    >
                      <h5>SECURE PAYMENTS</h5>
                      <span className={accordion.securepayments ? "open" : ""}><img src="../images/arrow-down.png" alt="" /></span> </div>
                    <div
                      className={`accordion-content ${accordion.securepayments ? "show" : ""
                        }`}
                    >
                      <div dangerouslySetInnerHTML={{ __html: productDetail?.secure_payments || "", }} />
                    </div>
                  </div>

                  {/* satisfaction guaranteed */}
                  {/* <div className="accordion-item-box">
                    <span className="accordion-item-span" id="guaranteed"></span>
                    <div
                      className="accordion-header"
                      onClick={() => toggleAccordion("guaranteed")}
                    >
                      <h5>SATISFACTION  GUARANTEED</h5>
                      <span className={accordion.guaranteed ? "open" : ""}><img src="../images/arrow-down.png" alt="" /></span> </div>
                    <div
                      className={`accordion-content ${accordion.guaranteed ? "show" : ""
                        }`}
                    >
                      <div dangerouslySetInnerHTML={{ __html: productDetail?.satisfaction_guaranteed || "", }} />
                    </div>
                  </div> */}




                  {/* Fit & Sizing */}
                  <div className="accordion-item-box">
                    <span className="accordion-item-span" id="size-chart"></span>
                    <div
                      className="accordion-header"
                      onClick={() => toggleAccordion("fit")}
                    >
                      <h5>FIT & SIZING</h5>
                      <span className={accordion.fit ? "open" : ""}><img src="../images/arrow-down.png" alt="" /></span> </div>
                    <div
                      className={`accordion-content ${accordion.fit ? "show" : ""
                        }`}
                    >
                      <div dangerouslySetInnerHTML={{ __html: productDetail?.fit_size || "", }} />
                      <div className="tab-pane-size">
                        <div className="size-left">
                          <TabSize />
                          <div className="note-box">
                            <p> <span>Note:</span> This is a standard size guide for the basic body measurements. Length of garments may vary as per style and type. </p>
                          </div>
                          <div className="measurements-box"> <img src="../images/video-call-blue.png" alt="" />
                            <Link to="/measurements" target="_blank">How to take Measurements</Link>
                          </div>
                        </div>
                        <div className="size-right"> <img src="../images/measurement-img.png" alt="img" /> </div>
                      </div>
                    </div>
                  </div>
                  {/* Size Chart */}
                  {/* <div className="accordion-item-box">
                    <span className="accordion-item-span" id="size-chart"></span>
                    <div
                      className="accordion-header"
                      onClick={() => toggleAccordion("sizeChart")}
                    >
                      <h5>SIZE CHART</h5>
                      <span className={accordion.sizeChart ? "open" : ""}><img src="../images/arrow-down.png" alt="" /></span> </div>
                    <div
                      className={`accordion-content ${accordion.sizeChart ? "show" : ""
                        }`}
                    >
                      
                    </div>
                  </div> */}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>


                  {isOpen && (  
                   <div className="custom-popupbox">
                    <div className="popup-box">
                      <div className="close-icon" onClick={() => setIsOpen(false)}>&times;</div>
                      <MtoPopup />
                    </div>
                    <div className="overlay"></div>
                   </div>
                  )}



    </Layout>
  );
}

export default ProductDetail; 